export const TEST_ID = 'desktopNavigationDropdownLink';
